<template>
    <div class="polyline-switch">
        <div :class="isPolyline ? '' : 'active'"
             class="item first"
             @click="switchPolylineMode(false)">
            <span>路 径</span>
        </div>
        <div :class="isPolyline ? 'active' : ''"
             class="item last"
             @click="switchPolylineMode(true)">
            <span> 直 线 </span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'polyline-switch',
    data () {
        return {
            isPolyline: false
        };
    },
    props: {
        mapController: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    methods: {
        switchPolylineMode (isPolyline) {
            if (isPolyline !== this.isPolyline) {
                this.isPolyline = isPolyline;
                this.mapController.switchPolylineMode(isPolyline);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.polyline-switch {
    background-color: white;
    border-radius: 4px;
    display: flex;

    .item {
        width: 50px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-left: 1px solid #00bcbe;
        cursor: pointer;
        font-size: 12px;

        &.active {
            color: white;
            background-color: #00bcbe;
        }
    }

    .first {
        border-left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .last {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}
</style>
